import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const root = css`
  grid-column: span 12;
  margin: 0 -${spacing.sm}px;

  svg {
    display: block;
    margin: ${spacing.sm}px auto;
    width: 270px;
  }
`;

export const heading = css`
  ${responsiveText.HEADING.SM};
  text-align: center;
  margin: 0 0 ${spacing.md}px 0;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 0 ${spacing.lg}px 0;
    `,
  )}

  span {
    display: block;
    margin: 0 auto ${spacing.sm}px auto;

    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        margin: 0 auto ${spacing.md}px auto;
      `,
    )}
  }
`;

export const scrollable = css`
  overflow-x: auto;
  scrollbar-width: none;
  padding: 0 ${spacing.sm}px;
`;

export const list = css`
  display: flex;
  align-items: stretch;
  margin: 0;
  width: 750px;
  padding: 0 0 ${spacing.md}px 0;
  column-gap: ${spacing.lg}px;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: 100%;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: 0 0 ${spacing.lg}px 0;
    `,
  )}
`;

export const item = css`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.base}px;
  flex-basis: 33%;
  list-style-type: none;
  margin: 0;
  border: 1px solid var(--brand-purple-10);
  border-radius: ${spacing.xs}px;
  width: 215px;
  padding: ${spacing.md}px;
  box-shadow: 0 8px 16px var(--neutral-black-10);

  h5 {
    margin: 0;
    ${responsiveText.BODY.MD};
    color: ${palette.purpleBase};
  }

  p {
    margin: 0;
    ${responsiveText.BODY.SM};
    color: var(var(--neutral-black-base));
  }
`;

export const itemHeader = css`
  display: flex;
  justify-content: space-between;
  margin: 0;
  ${responsiveText.HEADING.LG};
  color: ${palette.purpleBase};

  img {
    width: 32px;
  }
`;

export const itemLink = css`
  text-decoration: none;
  ${responsiveText.BODY.SM};
`;

export const serviceRating = css`
  text-align: center;

  h3 {
    margin: 0 0 ${spacing.xs}px 0;
    ${responsiveText.HEADING.SM};
  }

  a {
    display: block;
    margin: 0 auto;
    max-width: 270px;
  }

  img {
    display: block;
  }
`;
